import Bugsnag from '@bugsnag/js';

const apiKey = process.env.REACT_APP_BUGSNAG_API_KEY;

if (apiKey) {
    Bugsnag.start({
        apiKey,
        releaseStage: process.env.REACT_APP_RELEASE_STAGE || 'development',
        enabledReleaseStages: ['development', 'staging', 'production'],
        appVersion: process.env.REACT_APP_VERSION || '0.1.0',
    });
}

export default Bugsnag;



// WEBPACK FOOTER //
// ./src/bugsnag.js